class UserJourneyPickerItem {
  constructor(block) {
    this.block = block;

    this.selectors = {
      container: '.b-user-journey-picker__container',
      buttons: '.b-user-journey-picker__buttons',
      step: '.b-user-journey-picker__step',
      stepButton: '.b-user-journey-picker__step-button',
      stepTemplate: '.b-user-journey-picker__step-template',
      stepButtonText: '.b-user-journey-picker__step-button-text',
      stepButtonAction: '.b-user-journey-picker__step-button-action',
      backButton: '.b-user-journey-picker__back-button',
      section: '.b-user-journey-picker__section',
      titleBody: '.b-user-journey-picker__title-body',
    };

    this.classes = {
      stepOut: 'b-user-journey-picker__step--out',
      stepIn: 'b-user-journey-picker__step--in',
      backButtonHidden: 'b-user-journey-picker__back-button--hidden',
      sectionHidden: 'b-user-journey-picker__section--hidden',
      titleBodyHidden: 'b-user-journey-picker__title-body--hidden',
    };

    this.bootstrap();
  }

  bootstrap() {
    const container = this.block.querySelector(this.selectors.container);

    this.items = [];

    try {
      this.items = JSON.parse(container.dataset.items);
    } catch (error) {} // eslint-disable-line no-unused-vars,no-empty

    this.bindButtons();

    const buttons = this.block.querySelector(this.selectors.buttons);

    addEventListener('popstate', () => {
      this.openPageByLocation();
    });

    this.onHashChange(buttons);
    this.openPageByLocation();
  }

  openPageByLocation() {
    let { hash } = window.location;

    hash = hash.replace('#', '').split('/');

    if (hash.length > 0) {
      const id = hash[hash.length - 1];

      this.openPage(id);
    }
  }

  onHashChange(buttons) {
    window.addEventListener('hashchange', () => {
      this.setDevZoneLastPath();
    });

    buttons.addEventListener('click', () => {
      this.setDevZoneLastPath();
    });
  }

  // eslint-disable-next-line class-methods-use-this
  setDevZoneLastPath() {
    if (window.location.hash) {
      sessionStorage.setItem('dev-zone-last-path', window.location.hash);
    }
  }

  getPath(id) {
    let urlStack = [ id ];
    let safeWhile = 0;

    let currentId = id;

    const findId = item => item.id === currentId;

    while (currentId !== '' && safeWhile < 5) {
      const parent = this.items.find(x => findId(x)) || {
        id: '',
      };

      urlStack.unshift(parent.parent_id);

      currentId = parent.parent_id;

      safeWhile += 1;
    }

    urlStack = urlStack.filter(Boolean);

    return urlStack.join('/') || 'home';
  }

  bindButtons() {
    const stepButtons = this.block.querySelectorAll(this.selectors.stepButton);

    stepButtons.forEach(stepButton => {
      stepButton.addEventListener('click', event => {
        const { id } = stepButton.dataset;

        const childrens = this.items.filter(item => item.parent_id === id);

        if (childrens.length > 0) {
          event.preventDefault();

          this.openPage(id);

          history.pushState({}, null, `#${this.getPath(id)}`);
        }
      });
    });
  }

  openPage(id) {
    if (id === 'home') {
      id = ''; // eslint-disable-line no-param-reassign
    }

    const step = this.block.querySelector(this.selectors.step);
    const currentId = step.dataset.id || '';

    if (currentId === id) {
      return;
    }

    const parent = this.items.find(item => item.id === id) || { id: '' };
    const childrens = this.items.filter(item => item.parent_id === id);

    if (childrens.length > 0) {
      this.renderPage(parent, childrens);
    }
  }

  renderPage(parent, items) {
    const buttons = this.block.querySelector(this.selectors.buttons);
    const stepTemplate = this.block.querySelector(this.selectors.stepTemplate);
    const step = this.block.querySelector(this.selectors.step);

    const stepHTML = document.implementation.createHTMLDocument('');

    stepHTML.body.innerHTML = stepTemplate.innerHTML;

    const newStep = stepHTML.querySelector(this.selectors.step);
    const stepButton = stepHTML.querySelector(this.selectors.stepButton);

    items.forEach(item => {
      const node = stepButton.cloneNode(true);

      node.setAttribute('href', item.link || 'javascript:void(0)'); // eslint-disable-line no-script-url
      node.dataset.id = item.id;

      node.querySelector(this.selectors.stepButtonText).innerHTML =
        item.button_text;
      node.querySelector(this.selectors.stepButtonAction).innerHTML =
        item.button_action_text;

      newStep.appendChild(node);
    });

    stepButton.remove();

    newStep.dataset.id = parent.id;

    step.classList.add(this.classes.stepOut);
    newStep.classList.add(this.classes.stepIn);

    buttons.appendChild(newStep);

    setTimeout(() => {
      step.remove();
    }, 300);

    setTimeout(() => {
      newStep.classList.remove(this.classes.stepIn);
    }, 100);

    this.bindButtons();

    const backButton = this.block.querySelector(this.selectors.backButton);
    const section = this.block.querySelector(this.selectors.section);
    const titleBody = this.block.querySelector(this.selectors.titleBody);

    if (parent.id) {
      section.innerHTML = parent.button_text;
      backButton.setAttribute('href', `#${this.getPath(parent.parent_id)}`);
      backButton.classList.remove(this.classes.backButtonHidden);
      section.classList.remove(this.classes.sectionHidden);
      titleBody.classList.add(this.classes.titleBodyHidden);
    } else {
      section.innerHTML = '';
      backButton.classList.add(this.classes.backButtonHidden);
      section.classList.add(this.classes.sectionHidden);
      titleBody.classList.remove(this.classes.titleBodyHidden);
    }
  }
}

export default class UserJourneyPicker {
  constructor() {
    this.selector = '.b-user-journey-picker';
  }

  bootstrap() {
    this.wrappers = [ ...document.querySelectorAll(this.selector) ];

    this.wrappers.forEach(wrapper => new UserJourneyPickerItem(wrapper));
  }
}
